export default "__VITE_ASSET__B8m2fJQo__"